<template>
    <div >
        <!-- Modal -->
        <div v-if="OpenClose" class="modal fade show"
             tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
             style="display:block">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" @click="onClose()" class="btn-close" ></button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div class="modal-footer">
                        <button type="button"  @click="onConfirm()" :class="'btn btn-success'" >Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ConfirmDefault',
        emits: ['close', 'confirm'],
        props: {
            visible: false,
        },
        data(){
            return{
                OpenClose:this.visible
            }
        },
        methods:{
            onClose(){
                this.$emit('close', true);
            },
            onConfirm(){
                this.$emit('confirm', true);
            },
        },
        watch: {
            visible: function(newVal, oldVal) { // watch it
                this.OpenClose =newVal;
            }
        }
    }
</script>
